import useApiMutation from '@hooks/mutations/useApiMutation';

function useSendForgottenCodeMutation(options) {
  return useApiMutation('post', `/v1/forgotten`, options);
}

export default useSendForgottenCodeMutation;
